// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__Z9Ma4","pink":"About_pink__6NszG","green":"About_green__QSqVG","skills":"About_skills__ZAC-3"};